import { MarketDataShowcaseClient } from "./market-data-showcase-client";

export function MarketDataShowcase() {
  return (
    <div className="container max-w-6xl">
      <MarketDataShowcaseClient />
    </div>
  );
}
